import type { ReactNode } from 'react';
import type { RowTag } from '../types';
import { TAG_BADGE, TAG_LABEL } from '../utils';

export function TagBadge({ tag }: { tag: RowTag }) {
  return <span className={`clm-badge ${TAG_BADGE[tag]}`}>{TAG_LABEL[tag]}</span>;
}

export function Spinner({ label }: { label?: string }) {
  return (
    <span className="clm-spin" role="status" aria-live="polite">
      <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" style={{ animation: 'clm-rot 0.8s linear infinite' }}>
        <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2" />
        <path d="M8 2a6 6 0 0 1 6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      {label ? <span>{label}</span> : null}
    </span>
  );
}

export function Tick({ className }: { className?: string }) {
  return (
    <span className={className ?? 'clm-tick'} aria-hidden="true">
      <svg width="12" height="12" viewBox="0 0 12 12">
        <path d="M2.5 6.2l2.2 2.3 4.8-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}

export function Field({ label, children, hint, error }: { label: string; children: ReactNode; hint?: string; error?: string }) {
  return (
    <div>
      <span className="clm-label">{label}</span>
      {children}
      {hint ? <div className="clm-field-hint">{hint}</div> : null}
      {error ? <div className="clm-field-err">{error}</div> : null}
    </div>
  );
}
